import { type FC, type ReactNode } from 'react';
import { Trans } from 'react-i18next';
import cn from 'classnames';

interface BenefitsProps {
  icon: () => ReactNode;
  transKey: string;
  classNames?: string;
}

const Benefits: FC<BenefitsProps> = ({ icon, transKey, classNames }) => {
  return (
    <div className={cn('flex gap-2', classNames)}>
      {icon()}
      <p
        className={cn(
          'text-sm font-normal text-white/80 leading-1.2 [&>span]:text-gold [&>span]:font-bold',
        )}
      >
        <Trans
          i18nKey={transKey}
          defaults={transKey}
          components={{ span: <span />, br: <br /> }}
        />
      </p>
    </div>
  );
};

export { Benefits };
